import PatientFiles from './PatientFiles.js';

export default PatientFiles;
